function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4684 8.27973L6.10992 1.86719C4.56589 1.86719 3.31421 3.11887 3.31421 4.6629V54.7327C3.31421 56.2767 4.63512 57.256 6.17915 57.256L42.4684 63.9409C44.0124 63.9409 45.2641 62.6892 45.2641 61.1452V11.0754C45.2641 9.53141 44.0124 8.27973 42.4684 8.27973Z",
  fill: "#E6E6E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5584 8.27963L6.10992 0.912109C4.56589 0.912109 3.31421 2.16379 3.31421 3.70782V53.7776C3.31421 55.3216 4.56589 56.5733 6.10992 56.5733L40.5584 62.9858C42.1025 62.9858 43.3542 61.7341 43.3542 60.1901V11.0753C43.3542 9.53131 42.1025 8.27963 40.5584 8.27963Z",
  fill: "#F2F2F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00716 3.26862C3.51329 1.81329 4.77713 0.367899 6.28534 0.66317L43.4388 7.93693C44.7132 8.18642 45.4156 9.56529 44.8681 10.7428L43.8282 12.9797C41.9039 17.1188 37.4211 19.4296 32.9334 18.5957L13.3718 14.9609C9.81455 14.3 6.89178 11.769 5.72908 8.34276L4.00716 3.26862Z",
  fill: "#0055FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.7264 60.8753C45.1731 62.3029 43.9518 63.6977 42.4776 63.4433L5.10758 56.996C4.12986 56.8273 3.48723 55.881 3.69094 54.91C4.67346 50.2265 9.23307 47.1984 13.931 48.1096L36.6058 52.5073C40.2143 53.2072 43.148 55.8303 44.2456 59.3383L44.7264 60.8753Z",
  fill: "#E6E6E6"
});

function SvgPackPp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = React.forwardRef(SvgPackPp);
export default __webpack_public_path__ + "static/media/pack-pp.503cab4f.svg";
export { ForwardRef as ReactComponent };